module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch01"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("1")])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Sister Agatha stared at the black smoke around the tailpipe of the old Chrysler station wagon. This rusted-out bucket of bolts was what Our Lady of Hope Monastery graciously called transportation. Wiping her greasy hands on an old rag and grateful that her nagging arthritis hadn’t flared up while adjusting the carburetor, Sister Agatha walked around to the engine compartment and reluctantly closed the hood.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The engine nearly died, then picked up speed again slowly, sputtering and knocking like a mechanical asthmatic running the marathon. With luck, she might be able to make it back to Our Lady of Hope without having to walk or catch a ride. This early in the morning, there were few vehicles on the road.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The Antichrysler, as Sister Agatha had named the ancient vehicle, needed major engine work again. Though she could do minor repairs, employing skills she’d learned from her brother years ago, an automotive specialist was needed now.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Getting back into the car, she continued her journey back to the monastery with the spools of thread for a quilting project the other nuns were rushing to complete.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The sun was just coming up, but already she was late. She had a million things to do, including meeting Father Anselm at St. Francis’ Pantry, an outbuilding on monastery grounds that had been converted into a heated storeroom and an impressive larder. Supplies stored there were made available to anyone in need who asked for help. Father Anselm, the monastery’s chaplain, had consented to pick up a donation of canned goods from a grocer in the city, and deliver it to the monastery this morning.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Rolling down the window, she wondered how it could be so hot already down here in the Rio Grande Valley. Pressing down on the accelerator, she tried to coax the old car into a little more speed. Suddenly she heard a metallic thump. The engine sounded louder but the car seemed to have a little more pep, so she decided not to stop. Before she’d traveled another mile, however, she heard a siren and saw a sheriff’s car behind her, lights flashing.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Dear Lord, why are you testing me? You know I’ll flunk,” she muttered.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sister Agatha pulled over to the side of the road and parked, hoping the engine wouldn’t die. As she glanced in her rearview mirror, she saw a young deputy emerge and amble casually toward the station wagon. He seemed rather tall, and reminded her of an overgrown high school freshman, working on a cool, manly-looking stride in order to impress the girls. The dark sunglasses, she suspected, were standard equipment in the sheriff’s department, regardless of the time of day.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The officer smiled as he reached her window, then took off his sunglasses and slipped them into his shirt pocket. His eyes were pale blue, and bright with mischief despite the early hour. “Hello, Sister. I’m afraid I have some bad news for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Don’t tell me I was speeding, Deputy. As you can probably tell by looking, this car wouldn’t go more than forty miles an hour unless you drove it off the Rio Grande Gorge.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He gave her a wide, toothy grin. “I believe that, Sister. No, you weren’t violating the speed limit. But your muffler did fall off about a mile back down the road.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sister Agatha sighed loudly. “So, does that mean I’m getting a ticket for littering?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The young officer laughed. “How about a trade? I’ll let you off with a warning, and you light a candle for me back at the chapel.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sounds like a deal.” She wondered if his leniency was prompted by orders from on high. She didn’t mean God, of course. The new county sheriff was a long-time friend of hers. They’d dated back in high school and done more than that afterward during her wilder days. She hadn’t seen him except for an occasional glimpse on the street since she’d joined the monastery over his protests. But after twelve years, memories of their long friendship should have overwhelmed any lingering hurt.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Of course, it might have had nothing at all to do with Sheriff Tom Green, and everything to do with the fact that she was wearing a nun’s habit and it wasn’t Halloween. People tended to assume that her prayers would weigh more heavily in God’s sight. Little did they know. If God had been the kind to keep score, she could have rented herself as a lightning rod.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Seriously, Sister, it’s risky driving a car in this condition. You need to get it fixed before you get stopped for a vehicle emissions violation, especially while passing through pueblo land. It smokes like a campfire, and a new muffler is probably just the tip of the iceberg on this relic.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ll tell Reverend Mother what you said. But I’m afraid that our relic repair fund is very low at the moment. So how about it, Deputy? A few dollars toward a valve job or new oil pump for the God Squad’s station wagon?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sorry, Sister. I’m all tapped out this week.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’ll be on my way then.” She put the car in gear, praying nothing else would fall off, at least within the deputy’s sight, and gave him a wave.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Ten minutes later she passed through the monastery’s open gate. As she stepped out of the car, she felt a drop of rain, quickly followed by a dozen more. She looked up at the marble statue of Our Lord above the chapel entrance. “Why couldn’t you have sent rain a half hour ago when I was sweating like a pig trying to get that car started?” Sister Agatha said, then instantly contrite, she sighed. “Not that I’m trying to tell you what to do, of course.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As a native who’d grown up in the area, she knew that rain in New Mexico was a rare and welcome respite from the baking, midsummer heat of the desert, and the icy drops felt wonderful. Our Lady of Hope Monastery, a former farmhouse donated to the Church decades ago, was equipped with no system of cooling other than shade trees and windows that could be opened—providing the nun worked out regularly or had been blessed with the strength of Samson.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("There was a small fan in Reverend Mother’s office and another in the chapel, of course, but they were no match for the three-digit temperatures that could try the body and soul during July. The Sisters of the Blessed Adoration had modernized their old pre–Vatican II habits a long time ago, bravely raising the hemlines three inches from the floor, but they were still long sleeved, made of heavy serge, and nearly unbearable in hot weather.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Since it was still too early for Sister Bernarda to be in the parlor, Sister Agatha reached for her key. Unlocking the front parlor doors, she entered, locked the door behind her, then hurried across the room toward the next set of doors leading into the inner parlor. That doorway led to the enclosure where she would rejoin her cloistered sisters.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Few had access in and out of the monastery like an extern sister. It was a privilege that made her feel especially blessed. She enjoyed two very different worlds. Here, she shared in the communal, contemplative life of the monastery, where prayer for the needs of the world and faith in God became the very essence of what defined them. When her duties as an extern took her outside, however, she got to be part of a very different world—where individual tastes and desires were paramount and became the basis for action and progress.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Extern nuns were the links between the enclosure and the outside world. Someone had to let in a plumber or the computer tech when needed, do the shopping, take the sisters to the doctor—and, as she was constantly being reminded lately, take the Antichrysler back to the auto mechanic to be resuscitated.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("With soft footsteps, she made her way down the hall to the scriptorium. To emphasize a nun’s complete dedication to God, the white-stuccoed corridor walls were kept bare except for pictures of the saints and a crucifix here and there. The brick floors were barren. Slipping quietly through the open doorway, she entered the scriptorium.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You’re late,” Sister Bernarda snapped, looking up from the computer screen. She’d been converting a library’s catalogue into a digital format.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sister Bernarda’s voice always made a person want to stand up and salute. Sister had been a sergeant in the marines, serving for twenty years prior to joining the order. But Sister Agatha had found that despite the bluster, Sister Bernarda could be counted on—as a friend and as a sister.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“The car broke down again,” Sister Agatha explained, “and I’m afraid to take the interstate now.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sister Bernarda was the monastery’s only other extern nun. She and Sister Agatha were the only ones who had access to all the materials their scriptorium worked on. Here, in a modern twist to the monk’s age-old pursuit, they did computer work for several libraries, magazines, and newspapers, often working with quite valuable manuscripts that required special handling. Since that work held a tie to the outside world, the cloistered nuns only worked alongside them here when Sister Bernarda and she were running behind.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As the monastery bell filled the air with its rich, deep tones, she heard the sound of soft footsteps, and the opening and closing of doors as the sisters began their procession to the chapel. It was time for Terce.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Go on to your other duties, Sister Bernarda. I’ll take care of things here,” Sister Agatha said, exiting the scanning program on the computer for her. Lastly, she put the documents into a fireproof safe, a precaution the insurance company demanded despite the unique security already present in their walled, locked enclosure.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Once the door to the safe was locked, Sister Agatha went to the outer parlor to take up her duty as portress. As an extern nun she wouldn’t be joining the others in chapel—she would stay here to greet visitors and answer the telephone. Extern nuns weren’t required to go to chapel for Divine Office.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As the sisters’ chant rose from the chapel, a stillness unlike anything she’d ever experienced outside the monastery settled over the entire building and the grounds. It was as if nature itself held its breath, waiting on the word of God. Someone had once said that the angels walked in that silence.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Working as she prayed, Sister Agatha checked the front parlor’s turn, a revolving barrel-shaped shelf fitted into the outside wall. The device was used to bring small packages and mail into the cloister without the need to unlock the parlor doors. Children in the parish often referred to it as the nun’s drive-up window. During summer vacation, they loved to play tricks on the nuns, depositing everything from live lizards to get-out-of-jail-free Monopoly cards.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Today the turn only contained a folded piece of typing paper. Opening it, she read the message inside.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Pray the Lord forgives me. I’m going to hurt one of my friends.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The note sounded like it had come from one of the teens in town who was about to break up with her boyfriend. They got a lot of prayer requests of that nature these days—summer loves didn’t seem to last long.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sister placed the folded note in the small wooden box reserved for prayer requests. Each sister would draw from the box later, and pray on behalf of the petitioner they’d chosen at random.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sister walked back to the desk and began selecting passages from religious texts for their novice to study, and other, less complicated passages for their new postulant to read. As novice mistress, the responsibility for their instruction fell to her, though it was a job she’d never wanted.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("If only she could have explained to the abbess how much she disliked doing things that reminded her of the past—when she’d been Professor Mary Naughton, not Sister Agatha. That kind of nostalgia often led to comparisons, and to a heaviness of spirit that she neither liked nor understood. Not that being novice mistress was anything like being a professor, of course, but, teaching brought memories of her years at the university—a life she’d chosen to leave behind.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Now, at age forty-four, she couldn’t help but wonder what her own life might have been like if she’d continued her journalism career. She’d always shown a talent for investigative reporting.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It had been her brother Kevin’s long illness that had changed everything for her. She’d gone from being a reporter for an Albuquerque newspaper to teaching, in the hope of having regular work hours so she could be at home with him more. It had been a difficult time for her, but it had also been filled with unexpected blessings. While caring for her dying brother, she’d found new meaning in things she’d never valued before. Toward the end of his life, she’d received her calling from God—that stirring of the heart that drove a person to enter a monastery. And by finding God, she’d found herself.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("To this day, she remained as certain of her calling as she had been the day she’d entered the monastery, located just outside the small town where she’d spent her childhood. Not that monastery life was problem free—far from it. But twelve years as a Bride of Christ had given her a firm foundation and immeasurable strength to face whatever came her way.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She checked the time. Father Anselm would be coming by soon. She’d have to be ready to greet him along with her helpers, Sister Mary Lazarus, the monastery’s novice, and Celia, the postulant. Neither had taken final vows, and contact with the public was discouraged at this point of their formation, but the only person they’d see would be Father Anselm, so no rules would be violated.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("After private prayers were finished in chapel, Sister Agatha stood and went to the hall. Twisting the handle of the clapper, a small, wooden device reminiscent of castanets but much less melodious, she summoned the monastery’s postulant and novice. It was an efficient paging method, and very much linked to tradition, but, all things considered, she would have preferred a whistle or a bullhorn, like a high school coach.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sister Mary Lazarus appeared almost immediately, but their postulant, Celia, failed to appear.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As Sister Bernarda arrived to relieve her of portress duty, Sister Agatha focused on Mary Lazarus. “Follow me to the library, please,” Sister Agatha said. “We’ll start without Celia.”")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("As they entered the small library, Sister Agatha glanced back. Mary Lazarus was staring at a painting of the foundress of their order.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Seeing Sister Agatha looking at her, she smiled sadly. “I wonder how my friends will react once they learn I’m going to be taking my vows. I wrote them, but I haven’t heard back yet. None of them showed up for my investiture, but I guess I shouldn’t have been surprised. They all thought I was crazy when I entered the monastery.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sister Agatha smiled. “You should have seen the reaction of my old friends when I told them I was entering Our Lady of Hope. Even the Catholics among them were convinced that a monastery was a place where monks live, not nuns. They thought I was making a joke about going to corrupt monks.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mary Lazarus smiled, eyebrows raised. “I have a feeling your life on the outside was a little different from mine.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It had its moments,” Sister Agatha said, deliberately not elaborating. The fact was, in her younger days, she’d sown enough wild oats to qualify for a crop subsidy.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“It’s amazing how few Catholics realize that the word monastery simply means a place where religious men or women dwell in seclusion, and live a contemplative, cloistered life.” Sister Agatha looked toward the entrance. “Where "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("is")]), _vm._v(" Postulant Celia?” Patience was not a virtue she possessed this morning in any significant quantity, not after spending a fruitless hour working on the Antichrysler and being pulled over by a deputy sheriff half her age.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Celia was a trial to her. The girl meant well, but she had no conception of time. Admittedly, dealing with Celia, her own goddaughter, was difficult for her. Celia was a constant reminder of what she’d been like before she’d found her calling—and of the many duties she’d taken lightly. She’d agreed to be godmother to Ruth’s child, but soon afterward had lost all contact with them despite living less than twenty minutes away all that time. When Celia had come to them asking to be admitted into the monastery, it had come as a total surprise to Sister Agatha. She still wasn’t entirely comfortable around the postulant.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I better go find her,” Sister Agatha said. “I have a feeling she’s still in chapel. That girl can pray with total concentration.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Leaving Mary Lazarus to her work, she walked to the chapel. The only sound that could be heard was the hum of the giant, automatic baker the sisters used to make altar breads. These would be shipped all over the States and, along with the scriptorium’s work, had become a major source of the monastery’s livelihood, allowing them to become self-sustaining.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Silence was the normal condition of life at their monastery, and twelve years of practice had taught her to move with scarcely a sound. Walking into the chapel, she was surprised to see Celia was not there. She started back down the hall, then heard a sound in the sacristy. Turning, she entered the small room off the chapel and, to her surprise, saw Celia busy sewing one of the priest’s Mass vestments, the alb. The long, white garment with the tailored collar fit under the chasuble, the outer cape.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What on earth are you doing?” Sister Agatha demanded, surprised.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Celia dropped the needle and looked up, startled. “I…I was just trying to help. I noticed a split seam in the alb when I was helping Sister Clothilde with the laundry. I know that you’ve been having problems with your hands, so I thought I’d sew it for you.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It was bad enough that arthritis could make her joints all but useless at times, but to have a postulant treat her like an invalid was too much. “We have rules. You don’t choose your own work assignments. Is that clear?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Celia stood quickly, her head down. “I’m sorry, Mother Mistress. I was only trying to help.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hearing the monastery’s bell chime out unexpectedly, Sister Agatha put the garment away, despite protests from her swollen joints.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“We have to go. The bell is ringing off schedule. That probably means that the food donations I’ve been expecting have arrived early. We’d better hustle over to St. Francis’ Pantry.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Standing in the hall, Sister Agatha summoned Sister Mary Lazarus using the wooden clapper, then led her two charges outside and across the inner grounds of the monastery.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As they walked, she noticed Celia rubbing her hands against her black postulant’s dress. “Is something wrong?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“My hands really itch. Maybe I’m allergic to the starch Sister uses to press the alb.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hurry on ahead and wash your hands. Maybe that’ll help.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Yes, Mother Mistress.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When they arrived, Sister Mary Lazarus hurried inside the pantry to join Celia while Sister Agatha searched for Father Anselm. The parish pickup was there, parked by the side of the building, its bed filled with containers of canned goods. But where was the priest?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hearing a noise, she looked beneath the truck and saw him crouched on the other side, checking underneath the engine.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What happened, Father? Is something wrong with the truck?” She’d take this late-model pickup in a second over the monastery’s old station wagon. The thought made her pause. Was vehicle envy a sin?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He stood up and, as she did the same, answered her from across the bed of the vehicle. “I thought I’d poked a hole in the oil pan when I high-centered coming off the highway. But it’s okay.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Father Anselm was a pleasant, round-faced man with thinning hair and a sparkle in his eye. He brushed the dust and dirt off his black pants, then adjusted his clerical collar as he walked back around to her side of the truck. “Well, what do you think, Sister? Am I still presentable?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“You look very nice, Father,” Sister Agatha said, then with a tiny smile added, “for the most part.” Father was thirty-seven, still young for the post of chaplain of Our Lady of Hope Monastery. He was also headmaster at St. Charles, the small K–12 school in Bernalillo many local Catholic children attended. Though too modern in his thinking by most of the nuns’ standards, he clearly doted on them, and always made himself available to support them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“What do you mean, ‘for the most part,’ Sister?” He frowned. “I’ve really got to look sharp today for a meeting with the archbishop. That’s why I’m wearing a Roman collar instead of my usual street clothes.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sister smiled. “Well, I’m sure His Excellency will appreciate your color coordination. After all, the white Roman collar "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("does")]), _vm._v(" match your sneakers. But, just in case His Excellency isn’t in the mood to shoot a few baskets with you after Mass, you might want to bring out your dress shoes.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He looked down and groaned. “You’re right. I better go back to the rectory. I changed while I was talking to a parishioner on the phone, and never even stopped to think about my shoes.” He looked up at her, a twinkle in his eyes. “But who looks at their feet besides women, anyway? And extremely humble nuns, I should add.” He paused, then grinned. “And, by the way, you fit in with the former, not the latter.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He loved to tease her, but it was impossible not to like Father Anselm. “When’s your meeting?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He glanced at his watch. “In thirty minutes.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“In that case, let me help you carry the cases of food inside while my helpers do inventory and stock the shelves.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Sister, I don’t think you should do any heavy lifting with your arthritis. Let your helpers take care of that,” Father Anselm said, calling out to them. “Sisters?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Both women came out. Understanding what was needed, Celia quickly picked up the closest box from the bed of the truck and hurried toward the pantry. As she passed by the priest, Father Anselm touched her on the arm. “Annie?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Startled, Celia gasped and lost control of the grocery box. It slipped to the ground, and cans rolled in every direction. The young postulant dropped to her knees, scrambling to pick up everything.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Father Anselm crouched in front of Celia. “Annie, it "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("is")]), _vm._v(" you, isn’t it?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No, Father. My name is Celia. Perhaps I remind you of someone else.” She turned away, hurrying to refill the box, her face red as a beet.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I’m sure we’ve met before,” Father Anselm said gently, then grabbed the last two errant cans and placed them in the box.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I just have one of those faces,” Celia mumbled, bringing the box up to her waist.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Father Anselm turned away and, avoiding Sister Agatha’s gaze, carried a box inside.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sister Agatha stood where she was for a moment, gathering her thoughts. Something important had just happened but she couldn’t quite get a handle on it. The postulant’s full name was Celia Anne. She’d been at her christening, and as her godmother, she knew that for a fact. Had this denial been Celia’s way of separating herself from her former life, or was she trying to hide something?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sister Agatha saw the priest looking at the postulant as she came back to retrieve the last box. “Father, is something wrong?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No, not at all.” Turning and seeing the skepticism on Sister Agatha’s face, he smiled, and promptly switched the subject. “Thanks for noticing my shoes and saving my…day, Sister. I owe you one.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He stepped back outside and, seeing the back of the pickup empty and the tailgate closed, reached into his pocket for the truck keys. “Well, that takes care of the food. I’ll leave you and the sisters to finish stowing everything away.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Do you have time for a small glass of iced tea before you leave? It’ll help you relax before your meeting.” And, with luck, she’d get a hint about what had just happened.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He looked at his watch. “The nuns special blend?” Seeing her nod, he smiled. “I’ll make time. The monastery’s blend is wonderful.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As they walked back inside the pantry, Sister Agatha touched Celia on the arm, getting her attention. “Could you get some of our herbal tea for Father?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("After the postulant left, Sister Agatha turned to Father Anselm. “Make sure you don’t wear white socks with your dress shoes. And that’s my last fashion tip for the day,” she added with a wry smile.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("He chuckled. “I’ll take it, even if it comes from someone who knows what she’ll be wearing the rest of her life.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Celia joined them just then with the iced tea, which she presented nervously to the priest.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As Father took the opportunity to study Celia’s face again, Sister Agatha studied him. There was definitely something going on. She’d started to ask him a question, when he stood up, glancing at his watch. “I better get going,” he said taking several quick swallows of the tea. “I’ve got to hurry to the rectory and change these shoes, or I’ll be late for sure.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She suppressed a disappointed sigh. She’d have to get to the bottom of things later.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("After Father left, Sister Agatha and her helpers got to work putting things away and taking inventory. As she began arranging the shelves, Sister Agatha noticed her own hands had begun to itch. Walking over to the sink, she washed them with plenty of soap. They felt better after that, but she couldn’t help but wonder if Celia was right and the culprit "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("was")]), _vm._v(" the new starch she’d purchased for the monastery.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Time slipped by quickly as they worked. When the job was near completion, she checked her watch and gasped. The morning was nearly gone. Remembering that the priest’s vestments still needed to be mended before Mass, she reluctantly sent Celia back to the sacristy to finish the repairs. There was no time for her to do it herself now.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("When the bells rang twenty minutes later, Sister Agatha directed the novice to join the nuns, and then hurried to the sacristy for one final look around to make sure everything was ready for Father Anselm.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Noting that Celia had already joined the sisters in chapel, she gave the vestments a quick once-over. She had to admit, Celia had done a good job. Sister Agatha placed the alb in the two-way drawer, which could be opened from the priest’s side of the room or the cloistered side, and positioned it so the garments were in full view. She was ready to leave when Father Anselm rushed into the room, wearing tennis shorts and a T-shirt.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Hello, Sister!” He beamed her a wide smile from the other side of the partition. “I have a tennis match right after mass with one of our parish’s biggest benefactors,” he explained. “Do me a favor? Don’t tell Reverend Mother I’m wearing tennis clothes beneath my vestments. Last time, she told His Excellency, and I came within an inch of having my mail forwarded to Kingdom Come.” He placed his tennis racket against the wall.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“How did the meeting with the archbishop go?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“I postponed it because I had to make an unscheduled visit to a parishioner.” He grimaced. “That won’t impress the archbishop much, particularly since he hasn’t been feeling well. But I’ll try to fix things later and, with luck, save the day with a Hail Mary pass.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("She forced herself not to laugh. “I’d like to talk to you about Celia after Mass, if possible.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Can’t do it today. Maybe tomorrow. Okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Hearing the nuns in the chapel chanting the Divine Office, she hurried to the door. “Until later then, Father,” she whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sister Agatha took a seat in the first pew near the side door to the chapel and before long Father Anselm came out ready to celebrate Mass. She noted with a smile that he’d remembered not to wear sneakers.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The chapel, like most of the other rooms in the former farmhouse, had been converted to fit the needs of their cloistered order. The nuns who’d taken a vow of enclosure were separated from the priest and the faithful who came from the community by a grille that took up one side of the church. During communion, the nuns walked single file to an opening in the grille and, there, received the host.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As extern nuns, Sister Bernarda and Sister Agatha came to Mass but remained outside the enclosure. Afterward, they’d stay and visit with the parishioners, though usually only a few came to daily Mass, like today.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("After several minutes had gone by, she realized that Father Anselm seemed to be having a problem. His face was pale and he was swallowing repeatedly, as if sick to his stomach and fighting to keep from vomiting. Sister Agatha glanced over at Sister Bernarda, who also seemed worried.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Mass continued, but as Father began to consecrate the bread and wine, he staggered back. He swayed slowly for a moment and fell to his knees, retching violently. Then, clutching his chest, he began to gasp for air.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sister Agatha rose and hurried to the end of the pew to go help him. Father Anselm was trying to stand up by leaning against the altar, but the effort was too much for him. He collapsed, dragging the cloth and the vessels on it down to the floor with a crash.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("When Sister Agatha reached him a second later, her heart sank. Father lay on the red brick floor, his body racked by convulsions. His face was contorted in pain, and his hands grabbed at his chest. He was shivering in the eighty-degree room as if freezing to death, yet his brow was wet with perspiration.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“Everything hurts,” he whispered in a broken voice. “But the bells are…comforting. They’re ringing nearby. Can you hear them? It’s a beautiful sound.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As she knelt by the fallen priest, Sister Bernarda joined her. “I ran to the parlor and called nine-one-one.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sister Agatha nodded. Father’s face was rigid, as if all his facial muscles had stopped working. Then he lay perfectly still.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“He doesn’t have a pulse. Is he breathing?” she asked Sister Bernarda, who was crouched low, her ear against his chest.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("“No. We need to start CPR now.” Sister Bernarda loosened Father’s collar, then wiped the saliva away from his mouth with a handkerchief and checked that his throat was clear. “I’ll give him some air, Sister, you start with the heart massage.”")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Sister Agatha nodded grimly, remembering their drills with the practice dummy months ago.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("They began to work, but deep down Sister Agatha knew it was too late. Father Anselm’s eyes were open, staring blankly at the ceiling, looking only at the face of God.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f96afeb4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781429909587_ch01.vue
// module id = 78
// module chunks = 0